const tools = {
    isOverlap: function (idOne, idTwo, offset = 0) {
        if (!idOne || !idTwo) {
            return false
        }
        // offset偏移量
        var objOne = document.getElementById(idOne),
            objTwo = document.getElementById(idTwo)
        
        if (!objOne || !objTwo) {
            return false
        }
            // offsetOne = objOne.offset(),
            // offsetTwo = objTwo.offset(),
            // topOne = objOne.offsetTop,
            // topTwo=objTwo.offsetTop,
            // leftOne=objOne.offsetLeft,
            // leftTwo=objTwo.offsetLeft,
            // widthOne = objOne.offsetWidth,
            // widthTwo = objTwo.offsetWidth,
            // heightOne = objOne.offsetHeight,
            // heightTwo = objTwo.offsetHeight;
        // var leftTop = leftTwo > leftOne && leftTwo < leftOne+widthOne 
        //         && topTwo > topOne && topTwo < topOne+heightOne,
        //     rightTop = leftTwo+widthTwo > leftOne && leftTwo+widthTwo < leftOne+widthOne 
        //         && topTwo > topOne && topTwo < topOne+heightOne,
        //     leftBottom = leftTwo > leftOne && leftTwo < leftOne+widthOne 
        //         && topTwo+heightTwo > topOne && topTwo+heightTwo < topOne+heightOne,
        //     rightBottom = leftTwo+widthTwo > leftOne && leftTwo+widthTwo < leftOne+widthOne 
        //         && topTwo+heightTwo > topOne && topTwo+heightTwo < topOne+heightOne;
        
        // return leftTop || rightTop || leftBottom || rightBottom;

        var res = false
        console.log('isOverlap', objOne.getBoundingClientRect().top, objOne.offsetHeight, offset , objTwo.getBoundingClientRect().top)
        if (objOne.getBoundingClientRect().top + objOne.offsetHeight - offset >= objTwo.getBoundingClientRect().top) {
            res = true
        }
        return res
    },
    getUUID: function () {
        const s = [];
        const hexDigits = '0123456789ABCDEF';
        for (let i = 0; i < 36; i++) {
          s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-';
      
        const uuid = s.join('');
        return new String(uuid);
    }
}
export default tools




// WEBPACK FOOTER //
// ./src/plugin/tools/tools.js